<template>
  <div v-if="order.isUnclaimed" class="mb-5">
    <!-- 
        TODO: Translations didnt match anymore - recheck


     -->
    <div class="box" id="account-options-existing">
      <div class="columns is-vcentered dialog-option__columns">
        <div class="column">
          <h3 class="has-text-weight-bold">{{ $t('account.existing-account-question') }}</h3>
          <p>{{ $t('account.link-order-to-existing-account') }}</p>
        </div>
        <div class="column">
          <button class="button is-light" @click="toggleAddToAccount" aria-controls="orderToAccount">{{ $t('account.add-to-existing-account') }}</button>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6-widescreen is-offset-3-widescreen">
          <b-collapse aria-id="orderToAccount" animation="fade" :open.sync="addToAccountOpen" aria-live="polite">
            <!-- <div slot="trigger" class="panel-heading" role="button" aria-controls="orderToAccount">
                    <strong>Bestellung zu bestehenden Account hinzuzufügen</strong>
                  </div> -->
            <ValidationObserver v-slot="{invalid}">
              <form class="panel p-2">
                <b-message type="is-danger" has-icon v-if="loginError" aria-live="assertive" role="alert">
                  <strong>{{ $t('errors.invalid-user-data') }}</strong>
                  <p>{{ $t('errors.check-input') }}</p>
                </b-message>

                <!-- needs login if not logged in -->
                <div v-if="!hasUser">
                  <div v-if="!showPasswordReset">
                    <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{errors}">
                      <b-field :label="$t('general.email')" label-for="login-email">
                        <b-input aria-describedby="error-email" id="login-email" v-model="email" inputmode="email"></b-input>
                        <p id="error-email" class="help is-danger" v-for="error in errors" :key="error" aria-live="assertive" role="alert">{{ error }}</p>
                      </b-field>
                    </ValidationProvider>
                    <ValidationProvider name="Passwort" :rules="{required: true}" v-slot="{errors}">
                      <b-field :label="$t('general.password')" label-for="login-password">
                        <b-input aria-describedby="error-password" id="login-password" type="password" v-model="password" password-reveal></b-input>
                        <p id="error-password" class="help is-danger" v-for="error in errors" :key="error" aria-live="assertive" role="alert">{{ error }}</p>
                      </b-field>
                    </ValidationProvider>
                    <b-button class="is-fullwidth mt-4" type="is-primary" :disabled="invalid" @click="add">{{ $t('general.add') }}</b-button>

                    <b-button class=" is-size-7 mx-auto is-block" type="is-text" @click="showPasswordReset = true">{{ $t('account.password-forgotten') }}</b-button>
                  </div>
                  <div v-if="showPasswordReset">
                    <LoginWindow :showReset="true" />
                    <b-button class=" is-size-7 mx-auto is-block" type="is-text" @click="showPasswordReset = false">{{ $t('account.back-to-login') }}</b-button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="box" id="account-options-new">
      <div class="columns is-vcentered  dialog-option__columns">
        <div class="column">
          <h3 class="has-text-weight-bold">{{ $t('account.no-account-question') }}</h3>
          <p>{{ $t('account.create-account-claim') }}</p>
        </div>
        <div class="column">
          <button class="button is-light" @click="toggleNewAccount" aria-controls="accountFromOrder">{{ $t('account.create-account') }}</button>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6-widescreen is-offset-3-widescreen">
          <b-collapse v-if="!hasUser" aria-id="accountFromOrder" animation="fade" :open.sync="newAccountOpen" aria-live="polite">
            <!-- <button slot="trigger" class="panel-heading" role="button" aria-controls="accountFromOrder">
          <strong>Account anlegen</strong>
        </button> -->
            <b-message type="is-danger" has-icon v-if="registerErrors && registerErrors.length > 0" aria-live="assertive" role="alert">
              <ul>
                <li v-for="(e, i) in registerErrors" :key="i">{{ e.value }}</li>
              </ul>
            </b-message>
            <ValidationObserver v-slot="{invalid}">
              <form class="panel p-2">
                <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{errors}">
                  <b-field :label="$t('general.email')" label-for="from-account-email">
                    <b-input id="from-account-email" aria-describedby="from-account-error-email" v-model="email" inputmode="email"></b-input>
                    <p id="from-account-error-email" class="help is-danger" v-for="error in errors" :key="error" aria-live="assertive" role="alert">{{ error }}</p>
                  </b-field>
                </ValidationProvider>
                <ValidationProvider name="Passwort" :rules="{required: true, min: 6, confirmed: 'confirmation'}" v-slot="{errors}">
                  <b-field :label="$t('general.password')" label-for="from-account-password">
                    <b-input id="from-account-password" aria-labelledby="from-account-error-password" type="password" v-model="password" password-reveal></b-input>
                    <p id="from-account-error-password" class="help is-danger" v-for="error in errors" :key="error" aria-live="assertive" role="alert">{{ error }}</p>
                  </b-field>
                </ValidationProvider>
                <ValidationProvider name="Passwort wiederholen" vid="confirmation" :rules="{required: true, min: 6}" v-slot="{errors}">
                  <b-field :label="`${$t('general.password')} ${$t('general.retry')}`" label-for="from-account-password-verify">
                    <b-input id="from-account-password-verify" aria-describedby="from-account-error-password-verify" type="password" v-model="passwordVerify" password-reveal></b-input>
                    <p id="from-account-error-password-verify" class="help is-danger" v-for="error in errors" :key="error" aria-live="assertive" role="alert">{{ error }}</p>
                  </b-field>
                </ValidationProvider>

                <b-button class="is-fullwidth mt-4" type="is-primary" :disabled="invalid" @click="register">{{ $t('account.create-account') }}</b-button>
              </form>
            </ValidationObserver>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LoginWindow from '@/components/Auth/LoginWindow'
export default {
  name: 'RegisterFromOrderDialog',
  components: {
    LoginWindow,
  },
  computed: {
    ...mapGetters({
      hasUser: 'hasUser',
    }),
  },
  props: {
    order: Object,
  },
  methods: {
    async register() {
      const res = await this.$store.dispatch('$_order/registerFromOrder', {
        email: this.email,
        password: this.password,
        token: this.order.token,
        orderId: this.order.id,
        phone: this.order.customer.phone,
        sex: this.order.customer.sex,
        firstName: this.order.customer.firstName,
        lastName: this.order.customer.lastName,
        address: this.order.customer.address,
        country: this.order.customer.country,
        zip: this.order.customer.zip,
        city: this.order.customer.city,
      })
      if (res.success) {
        await this.$store.dispatch('login', {
          usr: this.email,
          pwd: this.password,
        })
      } else {
        this.registerErrors = res.errors
      }
    },
    async add() {
      if (this.hasUser) {
        this.$store.dispatch('$_order/claimOrderForUser', {
          token: this.order.token,
          id: this.order.id,
        })
      } else {
        const unsubscribe = await this.$store.subscribe(mutation => {
          if (mutation.type == 'ACCESS_TOKEN_UPDATED') {
            this.$store.dispatch('$_order/claimOrderForUser', {
              token: this.order.token,
              id: this.order.id,
            })
            unsubscribe()
          }
        })
        this.loginError = false
        let res = await this.$store.dispatch('login', {
          usr: this.email,
          pwd: this.password,
        })
        this.loginError = !res.success
      }
    },

    toggleAddToAccount() {
      this.addToAccountOpen = !this.addToAccountOpen
      this.newAccountOpen = false
    },
    toggleNewAccount() {
      this.newAccountOpen = !this.newAccountOpen
      this.addToAccountOpen = false
    },
  },
  data() {
    if (this.order) {
      return {
        password: '',
        email: this.order.customer.email,
        isOpen: false,
        isOpenLink: false,
        passwordVerify: '',
        loginError: false,
        registerErrors: [],
        newAccountOpen: false,
        addToAccountOpen: false,
        showPasswordReset: false,
      }
    }
    return {
      password: '',
      email: '',
      isOpen: false,
      isOpenLink: false,
      passwordVerify: '',
      loginError: false,
      registerErrors: [],
      newAccountOpen: false,
      addToAccountOpen: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-option__columns {
  margin-bottom: 0 !important;
}
</style>
